/**
 * Where "Download the app" leads. A OneLink: it sends a phone to its own store
 * and a desktop to the store page, so every surface that offers the app uses
 * this one link rather than choosing a store itself.
 */
export const WEHUNT_APP_STORE_URL = 'https://wehunt.onelink.me/XlRq/purruu8e'
